import {getWebConfig} from "../../api";
import {detectPlatform, getUrlParams, timeFormat} from "../../util/commonUtil";
import {tipToast} from "../../util/toastUtils";
import {sendCustomEvent} from "../../util/slog";
let webConfig = {
    "download_url": {
        "mac_arm": "",
        "mac_intel": "",
        "windows": ""
    },
    "current_version_win": {
        "version_name": "",
        "version_value": 0,
        "update_time": 0
    },
    "current_version_mac": {
        "version_name": "",
        "version_value": 0,
        "update_time": 0
    },
    "qywx": {
        "kefu": ""
    }
}

const download = (type,site) => {
    const platform = detectPlatform()
    const downloadType = getUrlParams('type')
    if (platform.includes('win') || platform.includes('mac')) {
        if (type === 'win') {
            console.log('win')
            if (!webConfig.download_url.windows) return  tipToast('暂无该系统安装包，敬请期待！')
            window.location.href = webConfig.download_url.windows
            sendCustomEvent('download_click',`pack-win site-${site}`)
            //下载界面无需跳
            if (window.location.href.includes('/download') && (!downloadType || downloadType.includes('win'))) return
            setTimeout(() => {
                window.location.href = __PAGE_DOMAIN__ + `download?type=${type}`
            },500)
            return
        }

        if (type === 'mac_m') {
            console.log('mac_m')
            if (!webConfig.download_url.mac_arm)  return  tipToast('暂无该系统安装包，敬请期待！')
            window.location.href = webConfig.download_url.mac_arm
            sendCustomEvent('download_click',`pack-mac_m site-${site}`)
            //下载界面无需跳
            if (window.location.href.includes('/download') && downloadType.includes('mac')) return
            setTimeout(() => {
                window.location.href = __PAGE_DOMAIN__ + `download?type=${type}`
            },500)
            return
        }

        if (type === 'mac_intel') {
            console.log('mac_intel')
            if (!webConfig.download_url.mac_intel)  return  tipToast('暂无该系统安装包，敬请期待！')
            window.location.href = webConfig.download_url.mac_intel
            sendCustomEvent('download_click',`pack-mac_intel site-${site}`)
            //下载界面无需跳
            if (window.location.href.includes('/download') && downloadType.includes('mac')) return
            setTimeout(() => {
                window.location.href = __PAGE_DOMAIN__ + `download?type=${type}`
            },500)
            return
        }

    } else {
        $('#contactUsDialog').css('display','flex')
    }
}

$(function () {
    //发送访问日志
    sendCustomEvent('view',window.location.href)
    let platform = detectPlatform()

    getWebConfig().then(res => {
        if (res.code === 1) {
            webConfig = res.data
            if (webConfig.qywx.kefu) {
                $('#kefuQr').attr('src', webConfig.qywx.kefu);
                $('#contactQr').attr('src', webConfig.qywx.kefu);
                $('#kefuLoading').hide()
                $('#kefuQr').show()
            }
            $('#winVersion').text(`版本号：V${webConfig.current_version_win.version_name !== '' ? webConfig.current_version_win.version_name : '0.0.0'} | 更新时间：${timeFormat(new Date(webConfig.current_version_win.update_time * 1000),'yyyy-MM-dd')}`)
            $('#winVersionBottom').text(`版本号：V${webConfig.current_version_win.version_name !== '' ? webConfig.current_version_win.version_name : '0.0.0'} | 更新时间：${timeFormat(new Date(webConfig.current_version_win.update_time * 1000),'yyyy-MM-dd')}`)
            $('#macVersion').text(`版本号：V${webConfig.current_version_mac.version_name !== '' ? webConfig.current_version_mac.version_name : '0.0.0'} | 更新时间：${timeFormat(new Date(webConfig.current_version_mac.update_time * 1000),'yyyy-MM-dd')}`)
            $('#macVersionBottom').text(`版本号：V${webConfig.current_version_mac.version_name !== '' ? webConfig.current_version_mac.version_name : '0.0.0'} | 更新时间：${timeFormat(new Date(webConfig.current_version_mac.update_time * 1000),'yyyy-MM-dd')}`)
            $('.page_one_info').css('opacity','1')
        }
    })

    //下载完成界面显示win/mac安装教程
    const downloadType = getUrlParams('type')
    if (downloadType.includes('mac')) {
        $('#winList').hide()
        $('#macList').css('display','grid')
    } else {
        $('#winList').css('display','grid')
        $('#macList').hide()
    }

    //下载完成界面的重试按钮
    $('#reDownload').on('click',() => {
        const type = getUrlParams('type')
        if (type === 'mac_m') {
            download('mac_m','download-page')
        } else if (type === 'mac_intel') {
            download('mac_intel','download-page')
        } else {
            download('win','download-page')
        }
    })

    $('#topDownloadWin').on('click',() => {
        download('win','banner')
    })
    $('#topDownloadMacM').on('click',() => {
        download('mac_m','banner')
    })
    $('#topDownloadMacIntel').on('click',() => {
        download('mac_intel','banner')
    })

    $('#downloadWin').on('click',() => {
        download('win','home')
    })
    $('#downloadWinBottom').on('click',() => {
        download('win','home')
    })

    $('#downloadMacM').on('click',() => {
        download('mac_m','home')
    })
    $('#downloadMacMBottom').on('click',() => {
        download('mac_m','home')
    })

    $('#downloadMacIntel').on('click',() => {
        download('mac_intel','home')
    })

    $('#downloadMacIntelBottom').on('click',() => {
        download('mac_intel','home')
    })

    $('#contactUsClose').on('click',function () {
        $('#contactUsDialog').hide()
    })



    // 点击播放图片
    $('#playOneVideo').click(function() {
        var $video = $('#pageOneVideo');
        var videoSrc = __ASSETS_URL + `assets/video/pr_video.mp4?v=${Date.now().toString()}`; // 替换为实际视频链接

        // 隐藏播放按钮图片
        $(this).hide();

        // 设置视频源并播放
        $video.attr('src', videoSrc);
        // 显示控制器
        $video.prop('controls', true);
        $video[0].play();
    });

    // 视频播放结束事件
    $('#pageOneVideo').on('ended', function() {
        // 显示播放按钮图片
        $('#playOneVideo').show();

        // 重置视频（可选）
        $(this).currentTime = 0
        $(this).prop('controls', false);
    });

    //首页第二屏

    $('.page_two_tab_item').on('click',function (e) {
        $('.page_two_tab_item').each(function(index, element) {
            // 对每个元素执行操作
            element.classList.remove('page_two_tab_item_active')
            $('.page_two_tab_content_img')[index].classList.remove('page_two_tab_content_img_active')
        });
        $('.page_two_tab_item')[$(this).index()].classList.add('page_two_tab_item_active')
        $('.page_two_tab_content_img')[$(this).index()].classList.add('page_two_tab_content_img_active')
    })

    //首页第三屏

    $('.page_three_tab_item').on('click',function (e) {
        $('.page_three_tab_item').each(function(index, element) {
            // 对每个元素执行操作
            element.classList.remove('page_three_tab_item_active')
            $('.page_three_tab_content_img')[index].classList.remove('page_three_tab_content_img_active')
        });
        $('.page_three_tab_item')[$(this).index()].classList.add('page_three_tab_item_active')
        $('.page_three_tab_content_img')[$(this).index()].classList.add('page_three_tab_content_img_active')
    })

    //首页第五屏
    $('.page_five_content_item').on('click',function (e) {
        $('.page_five_content_item').each(function(index, element) {
            // 对每个元素执行操作
            element.classList.remove('page_five_content_item_active')
            $('.img_page_five')[index].classList.remove('page_five_tab_content_img_active')
        });
        $('.page_five_content_item')[$(this).index()].classList.add('page_five_content_item_active')
        $('.img_page_five')[$(this).index()].classList.add('page_five_tab_content_img_active')
    })
    //首页第七屏
    $('.page_seven_tab_item').on('click',function (e) {
        $('.page_seven_tab_item').each(function(index, element) {
            // 对每个元素执行操作
            element.classList.remove('page_seven_tab_item_active')
            $('.page_seven_tab_content_item')[index].classList.remove('page_seven_tab_content_img_active')
        });
        $('.page_seven_tab_item')[$(this).index()].classList.add('page_seven_tab_item_active')
        $('.page_seven_tab_content_item')[$(this).index()].classList.add('page_seven_tab_content_img_active')
    })
})
